import {Trans} from '@lingui/macro';
import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Handler, HandlerOf} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {Toggle} from '../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {isTeammateNamespace} from '../../helpers/models/namespaceHelpers';
import {InboxModel} from '../../models/api/inboxModel';
import {SettingsFieldLine} from './settingsFieldLine';
import {SettingsObjectsPicker, SettingsObjectsPickerProps} from './settingsObjectsPicker';

/*
 * Props.
 */

interface SettingsInboxesFieldProps {
  namespace: string;
  onChange: HandlerOf<boolean>;
  onPickerHeaderChange: Handler;
  onInboxChange: HandlerOf<InboxModel>;
  selectedInboxIds: ReadonlyArray<number>;
  isVisibleInAllInboxes: boolean;
  inboxes: ReadonlyArray<InboxModel>;
  subtitle: ReactNode;
}

/*
 * Style.
 */

const StyledSettingsObjectsPicker = styled(SettingsObjectsPicker)`
  margin-top: 10px;
`;

/*
 * Component.
 */

export const SettingsInboxesField: FC<SettingsInboxesFieldProps> = (props) => {
  if (isTeammateNamespace(props.namespace)) {
    return null;
  }

  const maybeRenderInboxesPicker = () => {
    if (props.isVisibleInAllInboxes) {
      return null;
    }

    /* See https://github.com/DefinitelyTyped/DefinitelyTyped/issues/39136#issuecomment-719950054 to justify this monstrosity... */
    return (
      <StyledSettingsObjectsPicker<FC<SettingsObjectsPickerProps<InboxModel>>>
        items={props.inboxes.map((i) => ({item: i, id: i.id}))}
        onHeaderChange={props.onPickerHeaderChange}
        onChange={props.onInboxChange}
        columns={[<Trans id="settingsobjectspicker-name">Name</Trans>]}
        selectedIds={props.selectedInboxIds}
        renderItem={(_index, item) => item.name}
      />
    );
  };

  return (
    <>
      <SettingsFieldLine
        title={<Trans id="settingstags-inboxaccess-title">Make available for any inbox</Trans>}
        subtitle={props.subtitle}
        content={<Toggle isChecked={props.isVisibleInAllInboxes} onChange={props.onChange} />}
      />
      {maybeRenderInboxesPicker()}
    </>
  );
};
